export const SESSION_EXPIRED_EVENT = 'app:session-expired';

export const triggerSessionExpired = (detail = {}) => {
  if (typeof window === 'undefined') return;
  window.dispatchEvent(new CustomEvent(SESSION_EXPIRED_EVENT, { detail }));
};

export const isSessionExpiredError = (error) => {
  return error?.response?.status === 401 || error?.__sessionExpired === true;
};